import { VClientPublicKeyRequest, VClientPublicKeyResponse, VCryptoAlgorithm, VCryptoHashFunction, VCryptoKey, VCryptoKey_VCryptoKeyStatus, VCryptoKey_VCryptoKeyType, VResponseCode } from '@datarock/protobuffers';
import { EncodedEndpoint } from './Encoded';
import { RSA } from '@datarock/cryptography';
import { dateToVDateTime } from '../utils/transforms';
import random from 'lodash/random';
async function cryptoKeyToVCryptoKey(key) {
    const kvals = await RSA.exportKey(key);
    return VCryptoKey.fromJSON({
        algorithm: VCryptoAlgorithm.RSA_OAEP,
        creationDate: dateToVDateTime(new Date()),
        hashFunction: VCryptoHashFunction.UNKNOWN_HASH_FUNCTION,
        keyId: random(100, 2147483647),
        keySize: 2048,
        mgf1HashFunction: VCryptoHashFunction.SHA_256,
        publicKey: RSA.jsonWebKeyToXML(kvals),
        status: VCryptoKey_VCryptoKeyStatus.ACTIVE,
        type: VCryptoKey_VCryptoKeyType.EXCHANGE
    });
}
class ClientPublicKeyEndpoint extends EncodedEndpoint {
    async getRequestInit({ clientPublicKey, sessionId }) {
        const vCryptoKey = await cryptoKeyToVCryptoKey(clientPublicKey);
        const requestBytes = VClientPublicKeyRequest.encode({
            clientPublicKey: vCryptoKey,
            sessionId
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    process(value, ...args) {
        var _a, _b;
        const decoded = super.process(value, args);
        const response = VClientPublicKeyResponse.decode(decoded);
        if (((_a = response.response) === null || _a === void 0 ? void 0 : _a.code) !== VResponseCode.SUCCESS) {
            throw new Error((_b = response.response) === null || _b === void 0 ? void 0 : _b.text);
        }
        return response;
    }
}
export const sendClientPublicKeyEndpoint = new ClientPublicKeyEndpoint({
    path: '/sessionsecurity',
    method: 'PUT',
    sideEffect: true,
    body: {},
    schema: VClientPublicKeyResponse
});
